import React, { useEffect, useState } from "react";
import ApproverTable from "components/ApproverTable/ApproverTable";
import { useDispatch, useSelector } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import LoadResolver from "components/LoadResolver";
import { toast } from "components/Toast/Toast";
import ApproverForm from "forms/Approver";

const ApproverEditor = ({ t }) => {
  const users = useSelector((state) => state.users);
  const approvers = useSelector((state) => state.approvers);
  const isUserLoading = useSelector((state) => state.users.isLoading);
  const isApproversLoading = useSelector((state) => state.approvers.isLoading);
  const isGroupsLoading = useSelector((state) => state.userGroups.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch.users.init();
    dispatch.userGroups.init();
    dispatch.approvers.load();
  }, []);

  // Approver edit form states
  const [showApproverForm, setShowApproverForm] = useState(false);
  const [approverToUpdate, setApproverToUpdate] = useState(null);

  const handleUpdate = (approverToUpdate) => {
    setApproverToUpdate(approverToUpdate);
    setShowApproverForm(true);
  };
  const handleDelete = async (approver) => {
    try {
      await dispatch.approvers.delete(approver);
      toast(undefined, t("approver_toast_delete_success"));
    } catch (error) {
      toast("error", `${t("approver_toast_delete_error")}: ${error}`);
    }
  };

  const handleFormClose = () => {
    setShowApproverForm(false);
    setApproverToUpdate(null);
  };

  return (
    <LoadResolver isLoading={isUserLoading || isGroupsLoading || isApproversLoading}>
      <div className="page-container">
        <h2>{t("approvers")}</h2>
        {showApproverForm ? (
          <ApproverForm
            approverToUpdate={approverToUpdate}
            formClose={handleFormClose}
            users={users.items}
            t={t}
          />
        ) : (
          <>
            <Button primary onClick={() => setShowApproverForm(true)}>
              {t("create_new")}
            </Button>
            <Divider />
            <ApproverTable
              items={approvers.items}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
              t={t}
            />
          </>
        )}
      </div>
    </LoadResolver>
  );
};

export default ApproverEditor;
